// src/components/IncitingIncidentTab.js
import React, { useState, useEffect } from 'react';

const IncitingIncidentTab = ({ data, onChange }) => {
  const [storyOpening, setStoryOpening] = useState(data.storyOpening || '');

  useEffect(() => {
    // Update the local state when the external data changes
    setStoryOpening(data.storyOpening || '');
  }, [data.storyOpening]);

  const handleStoryOpeningChange = (e) => {
    const updatedStoryOpening = e.target.value;
    setStoryOpening(updatedStoryOpening);
    onChange({ storyOpening: updatedStoryOpening });
  };


  return (
    <div className='tab-styling'>
      <p className='synopsis-paragraph'>Now that we've met the character(s) who pulls us through the story, we must describe the event that brings about the story in question.</p>
      <div className="nice-form-group">
      <label>Story Opening:</label>
      <textarea value={storyOpening} onChange={handleStoryOpeningChange} />
      <p className='synopsis-paragraph'>This can be hard one. Where does your story start? The story starts at a pivotal moment of change. What is the point of change when your character follows the path to accomplish their overall goal.</p>
      </div>
     
    </div>
  );
};

export default IncitingIncidentTab;
